import React from "react";
import stylesV2 from "./CheckInCardNew.module.scss";
import stylesV3 from "./CheckInCardNewV2.module.scss";
import { LegacyCard } from "components/LegacyCard";
import { Button } from "components/Button";
import { timeUntil } from "features/appointmentTime";
import { TimeWindow } from "types/timeWindow";
import { useSchedulingABVariant } from "../../scheduling/utils/useSchedulingABVariant";

interface CheckInCardProps {
  appointment: TimeWindow;
  onClick: (e: React.MouseEvent) => void;
  isSubmit: boolean;
  isDisabled?: boolean;
}

export const CheckInCardNew: React.FC<CheckInCardProps> = ({
  appointment,
  onClick,
  isSubmit,
  isDisabled = false,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const styles = isV3 ? stylesV3 : stylesV2;
  return (
    <LegacyCard className={styles.card}>
      <div className={styles.notice}>
        Your appointment is {timeUntil(appointment)} away.
      </div>
      <Button
        text="Submit"
        onClick={onClick}
        size="large"
        className={styles.button}
        disabled={isSubmit || isDisabled}
        renderAsDisabled={isSubmit || isDisabled}
        loading={isSubmit}
        autoFocus
      />
    </LegacyCard>
  );
};
